import firebase from "firebase";

export async function getSnapshot(snapshot: firebase.firestore.Query<firebase.firestore.DocumentData>){
    return await snapshot.get();
}